<template>
    <div id="form-separation-element">
        <div class="form-separation-element">
            <hr :style="hrStyle">
        </div>
    </div>
</template>

<script>
export default {
    name: "form-separation-element",
    props: {
        separationColor: {
            type: String,
            default: "#d3d3d3d3",
        },
        separatorStyle: {
            type: String,
            default: "solid",
        },
        separatorHeight: {
            type: String,
            default: "1px",
        },
        separatorBottom: {
            type: String,
            default: "20px",
        },
        separatorTop: {
            type: String,
            default: "20px",
        },
        separatorSide: {
            type: String,
            default: "0",
        },
    },
    computed: {
        hrStyle() {
            return {
                backgroundColor: this.separationColor,
                height: this.separatorHeight + "px",
                marginTop: this.separatorTop + "px",
                marginBottom: this.separatorBottom + "px",
                marginLeft: this.separatorSide + "px",
                marginRight: this.separatorSide + "px",
                border: "none",
            };
        },
    },
};
</script>
<style lang="scss" scoped>
#form-separation-element {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    background: linear-gradient(145deg, 
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    .form-separation-element {
        hr {
            border: none;
            transition: all 0.3s ease;
            border-radius: 2px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
